import { render, staticRenderFns } from "./viewFileZoom.vue?vue&type=template&id=1ca67e8c"
import script from "./viewFileZoom.vue?vue&type=script&lang=js"
export * from "./viewFileZoom.vue?vue&type=script&lang=js"
import style0 from "./viewFileZoom.vue?vue&type=style&index=0&id=1ca67e8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports